import React from 'react';

/**
 * Resposta para quem chega em /admin sem ser super admin.
 *
 * Diz "não encontrada", e não "acesso negado", de propósito: negar acesso
 * confirma que a rota existe e que há um painel atrás dela. Não custa nada em
 * usabilidade, porque nenhum usuário legítimo digita /admin por engano.
 *
 * Mesmo cartão para os três casos — logado sem a flag, erro ao verificar, e
 * caminho inexistente. Distinguir também seria informação.
 *
 * Sem botão de voltar: um link para a raiz daqui seria a dica que o texto
 * evita dar.
 */
const NaoEncontrado = () => (
  <div className="min-h-[100dvh] bg-slate-50 flex items-center justify-center px-5">
    <div className="bg-white border border-slate-200 rounded-2xl p-6 max-w-sm text-center">
      <p className="font-medium text-slate-900">Página não encontrada</p>
      <p className="text-sm text-slate-600 mt-1">
        O endereço que você acessou não existe.
      </p>
    </div>
  </div>
);

export default NaoEncontrado;
